const profile = {
  title: "My Profile",
  premiumBtn: "Go premium",
  orderInfoTitle: "Account permission info.",
  tableProduct: "Product",
  tableStatus: "Status",
  tablePermissionDate: "Permission date",
  tableValidPeriod: "Valid Period",
  validStauts: "Valid",
  expiredStauts: "Expired",
  noData: "No data",
};

export default profile;
